export const adyenConstants: AdyenURLConstants = {
  ADYEN_SDK_JS_URL: 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.43.0/adyen.js',
  ADYEN_SDK_JS_HASH: 'sha384-YjFx15k4Uc9TRivIWGdpSu0wtMyH5cnD3VyKIx/Qk0BKod0osE3s/Jvb2nlWSovM',

  ADYEN_SDK_CSS_URL: 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.43.0/adyen.css',
  ADYEN_SDK_CSS_HASH: 'sha384-9N2Z2Q52NG3GmPKAXjzfPyGAQNCLKNrtExVZyfQ/QcbebtRaSboSKxvN8dLM0rVI',
}

interface AdyenURLConstants {
  ADYEN_SDK_JS_URL: string
  ADYEN_SDK_JS_HASH: string

  ADYEN_SDK_CSS_URL: string
  ADYEN_SDK_CSS_HASH: string
}

export enum AdyenCVCPolicies {
  REQUIRED = 'required',
  OPTIONAL = 'optional',
  HIDDEN = 'hidden',
}

export enum AdyenActionSubtypes {
  CHALLENGE = 'challenge',
  FINGERPRINT = 'fingerprint',
}

export enum AdyenConstants {
  NO_BRAND_DETECTED = 'card',
}

export const MOUNT_ID = 'adyenActionHandler'
export const HIDDEN_MOUNT_ID = 'hiddenAdyenActionHandler'
